<template>
    <div class="page">
        <div class="page__bd">
        </div>
        <article class="weui-article">
            <div class="agreement-title">
                <h1>校圆通跑腿协议</h1>
            </div>
            <section>
                <section>
                    <h2>客户及自由服务人员系具备完全民事行为能力的自然人。校圆通跑腿平台所提供的各项服务运营权，均归属于本公司。</h2>
                </section>
                <section>
                    <h2>声明与承诺: </h2>
                    <p>（一） 您确认，在您注册成为校圆通跑腿平台用户或自由服务人员接受本服务之前，你已充分阅读、理解并接受本协议的全部内容，一旦您使用本服务，即表示您同意遵循本协议之所有约定。 本协议将成为您和校圆通跑腿平台之间具有法律约束力的文件。</p>
                    <p>（二） 您同意，本公司有权随时对本协议内容进行单方面的变更， 并以在本公司公告的方式予以公布，无需另行单独通知您；若您在本协议内容公告变更后继续使用本服务的，表示您已充分阅读、理解并接受修改后的协议内容，也将遵循修改后的协议内容使用本服务；若您不同意修改后的协议内容，您应停止使用本服务。 </p>
                    <p>（三） 您声明，在您同意接受本协议并注册成为校圆通跑腿用户或自由服务人员时，您是具有法律规定的完全民事权利能力和民事行为能力，能够独立承担民事责任的自然人；本协议内容不受您所属国家或地区的排斥。不具备前述条件的，您应立即终止注册或停止使用本服务。 </p>
                </section>
                <section>
                    <p>1. 校圆通跑腿平台是从属于但不限于校圆通微信公众号和名称为“校圆通”的APP应用的跑腿业务平台，是为高校在校师生的自由服务人 员提供自由服务人员信息管理、配送信息浏览与查询、配送交易配对与处理、订单查询与管理、代理配送费磋商与谈判、配送费用代收代付、争议调解等互联网信息服务和在线交易处理服务的网络平台。校圆通跑腿平台并非配送服务的需求方，亦非配送服务的提供者。在客户与自由服务人员达成交易的过程中，校圆通跑腿平台仅起居间摄合作用，校圆通跑腿平台并不参与客户与自由服务人员之间的配送交易。 客户与自由服务人员之间因履行配送合同发生争议的，应当根据合同相对性原则向对方主张权利，并自行协商处理或寻求校圆通跑腿平台调节争议。 </p>
                </section>
                <section>
                    <p>2. 客户是指在校圆通跑腿平台发布的配送订单的需求方。 </p>
                </section>
                <section>
                    <p>3. 客户对自己的账户及余额，对应手机号码有保管的义务，未尽到保管义务，需独立承担责任、损失。 </p>
                </section>
                <section>
                    <p>4. 该账户不允许用来从事违反相关法律法规的行为及活动，如违反法规或侵害到校圆通跑腿平台或他人合法权益，须自行承担全部责任和赔偿一切损失，与校圆通跑腿平台无关。 </p>
                </section>
                <section>
                    <p>5. 客户下单详细信息是本契约的组成部分，本契约自客户下单成功， 且将“包裹”交付给自由服务人员揽收成功后成立。客户下单委托配送的费用支出按照校圆通跑腿平台公示的收费规则收取，下单时校圆通跑腿平台会有相关提示，下单成功即表示接受该费用标准。 </p>
                </section>
                <section>
                    <p>6. 为保证物品安全、及时送达，客户下单时应履行以下义务： </p>
                    <p>1） 如实申报包裹的内件物品和物品价值，并准确、清晰地填写客户、收件人的名称、地址、联系电话等资料。如地址不正确、联系方式错误、收件人拒收等原因而导致无法按时送达的，客户仍需支付跑腿费用。</p>
                    <p>2） 根据包裹的内物性质（尤其是易碎品，生鲜瓜果），提供充 分的防破损措施，保障快件安全派送。 </p>
                    <p>3） 对于国家法律、法规禁止寄递的物品，客户不得隐瞒包裹的内件状况，客户有义务配合自由服务人员验视快件。自由服务人员对已接受委托后发现属于不能安全、合法运送的物品（包括但不限于危险品、违禁品），保留有拒绝运送的权利，并由客户承担违约责任，该物品将由自由服务人员经由本公司交送有关部门处理。客户匿报禁通和限通物品导致本公司、自由服务人员或第三人身或财产伤害的，客户应当向本公司、自由服务人员或第三人承担赔偿责任。 </p>
                </section>
                <section>
                    <p>7. 自由服务人员有权并有义务依法验视包裹，对信件以外的包裹按照国家有关规定当成验视，对违禁物品和拒绝验视的物品不予服务。本公司向客户提供交寄日起半年内的流水查询服务。 </p>
                </section>
                <section>
                    <p>8. 自由服务人员将快件送达收件人地址，经收件人在校圆通跑腿平台上点击确认收货，视为送达。若无收件人姓名，仅有收件单位地址，则由单位收件人员签字，视为送达。特殊部门单位（如高校行政部门）不能提供签字，以签收信息上传，视为送达。 </p>
                </section>
                <section>
                    <p>9. 赔偿标准：是否保价由客户自愿选择，贵重包裹建议选择保价。 </p>
                    <p>1） 若因自由服务人员原因造成包裹损毁，灭失的，将扣除本次佣金报酬。 </p>
                    <p>2） 若客户未选择保价，丢失、损毁、短少、文件/物品最高赔偿不超过1000元/单，如核销单、提单等重要文件，建议保价，否则按未保价文件标准赔付，另有约定的按约定办理。 </p>
                    <p>3） 若客户已选择保价，若包裹仅有部分毁损或内件短少，则按照投保金额和损失的比例赔偿。若包裹丢失、损毁、短少的，按照实际损失价值赔偿，但最高不超过包裹的保价金额。快件残值由本公司组织自由服务人员和客户双方协商处理；如折归客户，在核定赔偿金额时将减扣残值。 </p>
                    <p>4） 自由服务人员不承担丢失、损毁、短少导致的一切可预期利益损失或间接损失（例如包裹可能获得的收益、利润、实际 用途、商业机会、商业价值等。） </p>
                    <p>5） 保价费为包裹价值金额的0.5%，最低收费1元。 </p>
                </section>
                <section>
                    <p>10. 本协议由“校圆通”保留最终解释权。 </p>
                </section>
            </section>
        </article>

        <div class="weui-footer">
            <p class="weui-footer__links">
                <a href="javascript:void(0);" class="weui-footer__link">校圆通</a>
            </p>
            <p class="weui-footer__text">Copyright &copy; 2017-{{year}} aixyt.com</p>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      year: moment().format("YYYY")
    };
  }
};
</script>

<style scoped>
.agreement-title {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.watchword h2 {
  font-weight: bold;
}
.weui-footer {
  margin-bottom: 20px;
  left: 0px;
  right: 0px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>





// WEBPACK FOOTER //
// src/components/infos/PaotuiAgreement.vue